import { ReactElement } from "react"
import { TransportOrderTableRow } from "./TransportOrderTableRow"
import { columnDetailsByColumn, columns } from "./Columns"
import { AdminShipment, Shipment } from "@/model/transportorder/transportOrder"
import { FormattedMessage } from "react-intl"

export const TransportOrderTable = (props: {
    transportOrders: AdminShipment[]
    selectedTransportOrderId?: string
    onTransportOrderSelected: (transportOrder: Shipment) => void
}): ReactElement => {
    return (
        <table
            className={"table table-layout-fixed table-column-overflow-hidden table-bordered table-hover table-head-filled table-sticky tr.extendedRow"}
            data-testid={"TransportOrders_Table"}
        >
            <TransportOrderTableColGroup/>
            <TransportOrderTableHead/>
            <TransportOrderTableBody
                transportOrders={props.transportOrders}
                selectedTransportOrderId={props.selectedTransportOrderId}
                onTransportOrderSelected={props.onTransportOrderSelected}
            />
        </table>
    )
}

const TransportOrderTableColGroup = (): ReactElement => {
    const cols = columns.map(column => <col key={column} style={columnDetailsByColumn[column]}/>)
    return <colgroup>{cols}</colgroup>
}

const TransportOrderTableHead = (): ReactElement => {
    const tableHeads = columns.map(column => {
        const columnDetails = columnDetailsByColumn[column]
        return <th key={columnDetails.label} className={`ellipsis-1`}>
            <FormattedMessage id={columnDetails.label}/>
        </th>
    })

    return (
        <thead className="table-head">
            <tr>{tableHeads}</tr>
        </thead>
    )
}

const TransportOrderTableBody = (props: {
    transportOrders: Shipment[]
    selectedTransportOrderId?: string
    onTransportOrderSelected: (transportOrder: Shipment) => void
}): ReactElement => {

    const transportOrderRows = props.transportOrders.map(it =>
        <TransportOrderTableRow
            key={it.id}
            transportOrder={it}
            isSelected={it.id === props.selectedTransportOrderId}
            onSelect={props.onTransportOrderSelected}
        />
    )
    return (
        <tbody>
            {transportOrderRows}
        </tbody>
    )
}
